<template>
  <v-container fluid>
    <v-row row wrap>
      <v-col>
        <v-btn
          color="primary"
          outlined
          small
          @click="handleClickCloseLibrary"
          class="pull-left mr-5"
        >
          Back
        </v-btn>
        <span class="details-heading application-heading">
          External Layers Library
        </span>
        <v-icon
          size="18"
          title="Close panel"
          class="mr-2 pull-right"
          @click="handleClickClose"
          >fas fa-times</v-icon
        >
      </v-col>
    </v-row>

    <v-row class="justify-left scrollable-row">
      <v-col>
        <v-card
          v-for="source in sources"
          :key="source.id"
          class="pull-left mr-5 mb-5 card-equal-height"
          height="450"
          max-width="325"
        >
          <v-card-title>{{ source.title }}</v-card-title>
          <v-card-text class="scrollable-text">
            <div class="mb-3">{{ source.description }}</div>

            <div v-if="source.layers">
              <div v-for="layer in source.layers" :key="layer.id">
                <div v-for="sublayer in layer.sublayers" :key="sublayer.id">
                  <v-chip
                    v-if="sublayer.enabled"
                    small
                    color="primary"
                    outlined
                    class="mb-1 layer-chip"
                    :title="sublayer.title"
                    ><span class="layer-chip-span">{{
                      sublayer.title
                    }}</span></v-chip
                  >
                </div>
              </div>
            </div>

            <div
              v-if="source.attribution"
              class="mt-3 source-attribution"
              v-html="getAttribution(source)"
            ></div>
          </v-card-text>

          <v-spacer></v-spacer>
          <v-divider class="mx-4"></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleClickChangeLayer(source)">
              Select layer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";

import { MODULE_PREFIX_MAP_CONTROLS } from "@/store";
import { GET_MAP_CONTROLS_EXTERNAL_SOURCE_ID } from "@/store/actions.type";
import { getExternalLayersConfig } from "@/services/mapControls/mapControls.service";
import { getUrlDomain } from "@/common/basic.utilities";

const EMITTED_ACTIONS = {
  CLOSE_LIBRARY: "close-library",
  CLICK_CLOSE: "click-close",
};

export default {
  name: "MapControlsExternalLibrary",
  data: () => ({
    externalConfig: undefined,
  }),
  computed: {
    sources() {
      const sources = this.externalConfig?.filter((source) => source.enabled);
      return lodashOrderBy(sources, ["orderBy"]);
    },
  },
  async mounted() {
    this.externalConfig = await getExternalLayersConfig();
  },
  methods: {
    getAttribution(source) {
      if (source?.attribution) {
        const urlRegex = /https?:\/\/[^\s]+/g;
        return source.attribution.replace(
          urlRegex,
          (url) => `<a href="${url}" target="_blank">${getUrlDomain(url)}</a>`
        );
      }
      return null;
    },
    handleClickCloseLibrary() {
      this.$emit(EMITTED_ACTIONS.CLOSE_LIBRARY);
    },
    handleClickClose() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE);
    },
    handleClickChangeLayer(source) {
      this.$store.dispatch(
        MODULE_PREFIX_MAP_CONTROLS + GET_MAP_CONTROLS_EXTERNAL_SOURCE_ID,
        source.id
      );
      this.handleClickCloseLibrary();
    },
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.source-attribution {
  font-size: 0.7rem;
  font-style: italic;
}
.card-equal-height {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%; /* Ensures all cards have equal height */
}
.scrollable-row {
  max-height: 800px; /* Set the maximum height of the row */
  overflow-y: auto; /* Enable vertical scrolling */
  padding-right: 10px; /* Add some space for the scrollbar */
}
.scrollable-text {
  max-height: 450px; /* Allow the text area to grow and fill available space */
  overflow-y: auto; /* Enable vertical scrolling */
  padding: 16px; /* Optional: Add padding for better readability */
  margin-bottom: 16px; /* Optional: Ensure spacing before the actions */
}
.layer-chip-span {
  max-width: 160px;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.layer-chip >>> .v-chip__content {
  height: 24px;
  border-radius: 16px;
  padding: 0 6px;
}
</style>
